import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

interface AditoolsCardArgs {
  Element: HTMLDivElement;
  Args: {
    title: string;
    icon?: string;
    qaName?: string;
    bodyClass?: string;
    main?: boolean;
    tooltip?: string;
    clickAction?: (event: MouseEvent) => void;
  };
  Blocks: {
    header: [];
    tooltip: [() => void];
    default: [];
  };
}
export default class AditoolsCard extends Component<AditoolsCardArgs> {
  @tracked tooltipEnabled = false;

  get qaName() {
    return this.args.qaName ?? 'unnamed';
  }

  get _tooltip() {
    return this.args.tooltip ?? '';
  }

  @action checkboxClicked(event: MouseEvent) {
    if (this.args.clickAction) {
      this.args.clickAction(event);
    }
  }
  @action tooltipClicked(event: MouseEvent) {
    this.tooltipEnabled = true;
    if (this.args.clickAction) {
      this.args.clickAction(event);
    }
  }
  @action tooltipClosed() {
    this.tooltipEnabled = false;
  }
}
